"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedClientToBarSchema = exports.ClientToBarSchema = exports.ClientToBarClientContextUpdated = exports.ClientToBarContextUpdated = exports.ClientToBarUserPreferencesUpdated = exports.ClientToBarBarConfigUpdated = exports.WrappedBarToClientSchema = exports.BarToClientSchema = exports.BarToClientOpenURL = exports.BarToClientToggleHotKey = exports.BarToClientSaveUserPreferences = exports.BarToClientSaveBarConfig = exports.BarToClientResizeIframe = exports.BarToClientPing = void 0;
const zod_1 = require("zod");
const bar_1 = require("../bar");
const result_1 = require("../result");
const user_1 = require("../user");
/**
 * Tells the client that the bar is ready to get messages
 */
exports.BarToClientPing = zod_1.z.object({
    type: zod_1.z.literal("ping"),
});
/**
 * Tells the client to resize the iframe to the given height
 */
exports.BarToClientResizeIframe = zod_1.z.object({
    type: zod_1.z.literal("resize-iframe"),
    height: zod_1.z.string(),
});
/**
 * Tells the client to update the bar with the given configuration
 */
exports.BarToClientSaveBarConfig = zod_1.z.object({
    type: zod_1.z.literal("save-bar-config"),
    bar: bar_1.BarSchema,
});
/**
 * Tells the client to save the user preferences
 */
exports.BarToClientSaveUserPreferences = zod_1.z.object({
    type: zod_1.z.literal("save-user-preferences"),
    userPreferences: user_1.UserPreferencesSchema.partial(),
});
/**
 * Tells the client we received a hotkey
 */
exports.BarToClientToggleHotKey = zod_1.z.object({
    type: zod_1.z.literal("toggle-hotkey"),
});
/**
 * Tells the client to open the given url
 */
exports.BarToClientOpenURL = zod_1.z.object({
    type: zod_1.z.literal("open-url"),
    url: zod_1.z.string(),
    newTab: zod_1.z.boolean().optional(),
});
exports.BarToClientSchema = zod_1.z.discriminatedUnion("type", [
    exports.BarToClientPing,
    exports.BarToClientResizeIframe,
    exports.BarToClientSaveBarConfig,
    exports.BarToClientSaveUserPreferences,
    exports.BarToClientToggleHotKey,
    exports.BarToClientOpenURL,
]);
exports.WrappedBarToClientSchema = zod_1.z.object({
    version: zod_1.z.literal(1),
    type: zod_1.z.literal("bar-to-client"),
    messages: zod_1.z.array(zod_1.z.any()),
});
// =========================
// Client to bar
// =========================
exports.ClientToBarBarConfigUpdated = zod_1.z.object({
    type: zod_1.z.literal("bar-config-updated"),
    bar: bar_1.BarSchema,
});
exports.ClientToBarUserPreferencesUpdated = zod_1.z.object({
    type: zod_1.z.literal("user-preferences-updated"),
    userPreferences: user_1.UserPreferencesSchema,
});
exports.ClientToBarContextUpdated = zod_1.z.object({
    type: zod_1.z.literal("context-updated"),
    context: zod_1.z
        .object({
        providers: zod_1.z.record(zod_1.z.string(), result_1.Result),
    })
        .passthrough(),
});
exports.ClientToBarClientContextUpdated = zod_1.z.object({
    type: zod_1.z.literal("client-context-updated"),
    context: zod_1.z.object({}).passthrough(),
});
exports.ClientToBarSchema = zod_1.z.discriminatedUnion("type", [
    exports.ClientToBarBarConfigUpdated,
    exports.ClientToBarUserPreferencesUpdated,
    exports.ClientToBarClientContextUpdated,
    exports.ClientToBarContextUpdated,
]);
exports.WrappedClientToBarSchema = zod_1.z.object({
    version: zod_1.z.literal(1),
    type: zod_1.z.literal("client-to-bar"),
    messages: zod_1.z.array(zod_1.z.any()),
});
__exportStar(require("./encode"), exports);
